/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lodaspersonalnr2Inputs */



/**

* @param {_Field_Lodaspersonalnr2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_lodaspersonalnr2 = /** @type {((inputs?: _Field_Lodaspersonalnr2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lodaspersonalnr2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Lodas Personal-Nr.")
});
export { _field_lodaspersonalnr2 as "_field_lodasPersonalNr" }